import React from "react";
import Icon, { IconName } from "../icon";
var SearchButton = function SearchButton(_ref) {
    var openSearch = _ref.openSearch, style = _ref.style;
    return /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return openSearch();
        },
        className: "inline-block ml-2 z-30",
        style: style
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.SEARCH,
        className: "text-makroOrange w-6 lg:w-8",
        tooltip: "Suche",
        color: "current-color"
    }));
};
export default SearchButton;
